/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Review_P2Inputs */

const en_wc_tut_review_p2 = /** @type {(inputs: Wc_Tut_Review_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select text and click New Comment to add a comment balloon in the margin. Compare Documents shows the differences between two versions of a file.`)
};

/**
* | output |
* | --- |
* | "Select text and click New Comment to add a comment balloon in the margin. Compare Documents shows the differences between two versions of a file." |
*
* @param {Wc_Tut_Review_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_review_p2 = /** @type {((inputs?: Wc_Tut_Review_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Review_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_review_p2(inputs)
});
export { wc_tut_review_p2 as "wc.tut.review.p2" }